/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { CHANGE_PASSWORD_EMAIL } from './graphql';

export function useChangePasswordEmail() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [ChangePasswordEmail, { loading: apiLoading }] = useMutation(
    CHANGE_PASSWORD_EMAIL,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function changePasswordEmail(userId) {
    try {
      const res = await ChangePasswordEmail({
        variables: { userId },
      });
      if (res.data.changePasswordByEmail.code === 200) {
        setSuccessMessage('Email para troca da senha enviado com sucesso!');
      } else {
        setErrorMessage(
          'Não foi possível trocar a senha, tente novamente mais tarde.',
        );
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível trocar a senha, tente novamente mais tarde.',
      );
    }
  }

  return {
    changePasswordEmail,
    loading: isLoading,
  };
}
